import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import JACK_MENU_BUTTON_IMAGE_URL from '../../assets/jack-menu-button.png';
import { SUB_PAGE_HEADER_BACKGROUND_COLOR } from '../../styles/colors';
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background-color: ${SUB_PAGE_HEADER_BACKGROUND_COLOR};
  align-items: center;
  gap: 10px;
  padding: 5px 10px;
  h1 {
    color: white;
    font-size: 24px;
    margin: 0;
  }
  h2 {
    color: #aaaaaa;
    font-size: 20px;
    margin: 0;
  }
`;
const HEADER_TITLE_CSS = css `
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;
export const SubPageHeader = ({ title, omitExtraButtons, omitHomeLink }) => {
    const navigate = useNavigate();
    const onClickPlayNow = useCallback(() => {
        navigate('/');
    }, [navigate]);
    const iconElement = omitHomeLink ? (_jsx("img", { src: JACK_MENU_BUTTON_IMAGE_URL, title: 'Triplejack Poker', width: 64, height: 64 })) : (_jsx(Link, { to: '/', children: _jsx("img", { src: JACK_MENU_BUTTON_IMAGE_URL, title: 'Go To Triplejack Home', width: 64, height: 64 }) }));
    return (_jsxs("header", { css: CONTAINER_CSS, children: [iconElement, _jsxs("div", { css: HEADER_TITLE_CSS, children: [_jsx("h1", { children: "Triplejack Poker" }), _jsx("h2", { children: title })] }), !omitExtraButtons && (_jsx(Button, { variant: 'contained', size: 'large', color: 'secondary', onClick: onClickPlayNow, children: "Play Now!" }))] }));
};
